export default __webpack_public_path__ + "static/media/darkHouse.225ab5b5.svg";